declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    lpTag: any;
  }
}

let liveChatTrackingLoaded = false;

function loadLiveChatTracking() {
  if (liveChatTrackingLoaded === false) {
    // Define Engagement type (1 == proactive)
    let chatEngagementType = 0;

    if (
      Object.prototype.hasOwnProperty.call(window, 'lpTag') &&
      Object.prototype.hasOwnProperty.call(window.lpTag, 'events')
    ) {
      // Livechat Engagements are displayed on the page
      liveChatTrackingLoaded = true;
      window.lpTag.events.bind({
        eventName: 'OFFER_DISPLAY',
        func: function (eventData) {
          if (eventData.engagementType === 1) {
            // engagementType === 1 indicates that this is a proactive invite
            site.elcEvents.dispatch('track:liveChatProactiveDisplayed');
          }
        }
      });

      // Livechat was clicked on the page
      window.lpTag.events.bind({
        eventName: 'OFFER_CLICK',
        func: function (eventData) {
          chatEngagementType = eventData.engagementType;
          if (eventData.engagementType === 1) {
            // engagementType === 1 indicates that this is a proactive invite
            site.elcEvents.dispatch('track:liveChatProactiveInitiated');
          } else {
            // otherwise it was manual
            site.elcEvents.dispatch('track:liveChatManualInitiated');
          }
        }
      });

      // Livechat state change.
      window.lpTag.events.bind({
        eventName: 'state',
        func: function (eventData) {
          let engagementType = '';
          if (chatEngagementType === 1) {
            engagementType = 'Proactive';
          } else {
            engagementType = 'Manual';
          }
          if (eventData.state === 'preChat') {
            // When the survey before the chat is shown
            site.elcEvents.dispatch('track:liveChat' + engagementType + 'PreSurvey');
          }
          if (eventData.state === 'waiting') {
            // When the user submits the survey
            site.elcEvents.dispatch('track:liveChat' + engagementType + 'Waiting');
          }
          if (eventData.state === 'chatting') {
            // When the chat starts
            site.elcEvents.dispatch('track:liveChat' + engagementType + 'Chatting');
          }
        }
      });
    }
  }
}

export function init() {
  // Testing tracking signal from Tealium
  site.elcEvents.addListener('tealium:liveperson-loaded', function () {
    // Load the tracking after we launch LivePerson from Tealium
    loadLiveChatTracking();
  });

  // Load the tracking when we've implemented LivePerson from Drupal
  loadLiveChatTracking();
}
